import { createLocation, useHistory } from 'quartz-routing/react-router';
import { useCallback } from 'react';
import { shouldReloadLocation } from './useShouldReloadLocation';
import { getWindow } from '../utils/browser';
/**
 * Returns a navigate function that is aware of Academy's multi-app deployment.
 * For same-app targets it uses `history.push`/`replace`; for cross-app targets
 * it triggers a full page reload via `window.location`.
 */
export const useACNavigate = () => {
  const history = useHistory();
  const navigate = useCallback((to, options = {}) => {
    if (typeof to === 'number') {
      history.go(to);
      return;
    }
    const {
      replace = false,
      forceReload = false,
      state
    } = options;
    const toLocation = (() => {
      if (typeof to === 'string') {
        return createLocation(to, state, undefined, history.location);
      } else if (typeof to === 'function') {
        return to(history.location);
      }
      return to;
    })();
    if (forceReload || shouldReloadLocation(toLocation)) {
      var _options$href;
      const href = (_options$href = options.href) !== null && _options$href !== void 0 ? _options$href : history.createHref(toLocation);
      if (replace) {
        getWindow().location.replace(href);
      } else {
        getWindow().location.assign(href);
      }
      return;
    }
    if (replace) {
      history.replace(toLocation);
    } else {
      history.push(toLocation);
    }
  }, [history]);
  return navigate;
};